import api from "../../../api/axios";

const BASE = "/interdicoescim";
const DEFAULT_LIST_LIMIT = 5000;

export async function listarInterdicoesCim({
  q = "",
  ativo,
  limit = DEFAULT_LIST_LIMIT,
  offset = 0,
} = {}) {
  const { data } = await api.get(`${BASE}/listar`, { params: { q, ativo, limit, offset } });
  return {
    rows: Array.isArray(data?.data) ?data.data : [],
    meta: data?.meta || { limit, offset },
  };
}

export async function cadastrarInterdicaoCim(payload) {
  const { data } = await api.post(`${BASE}/cadastrar`, payload);
  return data?.data || data;
}

export async function salvarAcompanhamentoInterdicaoCim(id, payload) {
  const { data } = await api.patch(`${BASE}/${id}/acompanhamento`, payload);
  return data?.data || data;
}

export async function finalizarInterdicaoCim(id, payload) {
  const { data } = await api.patch(`${BASE}/${id}/finalizar`, payload);
  return data?.data || data;
}
